<script setup lang="ts">
import { defaultRichTextSizeClass, isValidRichTextSizeClass, normalizeRichTextSizeClass } from '~/unocss/text-sizes'

const props = defineProps({
  content: {
    required: true,
  },
  textSizeClass: {
    type: String,
    default: defaultRichTextSizeClass,
    validator: isValidRichTextSizeClass,
  },
  wordCount: {
    type: Number,
    default: 100,
  },
})

const sizeClass = computed(() => normalizeRichTextSizeClass(props.textSizeClass))

const showAll = ref(false)

const needsTruncation = computed(() => richTextWordCount(props.content) > props.wordCount)

const displayContent = computed(() => {
  if (!needsTruncation.value || showAll.value) return props.content
  return truncateRichText(props.content, props.wordCount)
})
</script>

<template>
  <div>
    <core-rich-text
      :content="displayContent"
      :text-size-class="textSizeClass"
    />
    <button
      v-if="needsTruncation"
      class="text-hover-accent lowercase mt-1"
      :class="sizeClass"
      @click="showAll = !showAll"
    >
      {{ showAll ? $t('labels.showLess') : $t('labels.readMore') }}
    </button>
  </div>
</template>
